/* ============================================
   KAFFEESACK PREMIUM — Main JS v1.0
   Cart · Drawer · Product · Header · Search
   Menu · Announcements · Animations · Utils
   ============================================ */

(function() {
  'use strict';

  var KS = window.KS || {};


  /* ═══════════════════════════════════════════
     1. UTILITIES
     ═══════════════════════════════════════════ */

  /* ── ATC Premium Feedback helpers ── */
  var _ksAudioCtx = null;
  function ksPlayDing() {
    try {
      if (!_ksAudioCtx) _ksAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
      var t = _ksAudioCtx.currentTime;
      var o1 = _ksAudioCtx.createOscillator(), g1 = _ksAudioCtx.createGain();
      o1.type = 'sine'; o1.frequency.setValueAtTime(1318, t); o1.frequency.exponentialRampToValueAtTime(1397, t + 0.06);
      g1.gain.setValueAtTime(0, t); g1.gain.linearRampToValueAtTime(0.1, t + 0.008); g1.gain.exponentialRampToValueAtTime(0.001, t + 0.35);
      o1.connect(g1); g1.connect(_ksAudioCtx.destination); o1.start(t); o1.stop(t + 0.4);
      var o2 = _ksAudioCtx.createOscillator(), g2 = _ksAudioCtx.createGain();
      o2.type = 'sine'; o2.frequency.setValueAtTime(1661, t + 0.05);
      g2.gain.setValueAtTime(0, t + 0.05); g2.gain.linearRampToValueAtTime(0.06, t + 0.058); g2.gain.exponentialRampToValueAtTime(0.001, t + 0.3);
      o2.connect(g2); g2.connect(_ksAudioCtx.destination); o2.start(t + 0.05); o2.stop(t + 0.35);
    } catch(e) {}
  }

  function ksFlyToCart() {
    var img = document.querySelector('.product-gallery img') ||
              document.querySelector('.product-single__media img') ||
              document.querySelector('.flickity-cell.is-selected img') ||
              document.querySelector('.product__media img, .product img[src*="cdn.shopify"]');
    var cart = document.querySelector('a.cartToggle') ||
              document.querySelector('.header__cart') ||
              document.querySelector('a[href="/cart"]') ||
              document.querySelector('[data-cart-count]');
    if (!img || !cart) return;
    var ir = img.getBoundingClientRect(), cr = cart.getBoundingClientRect();
    var sz = Math.min(ir.width, 120);
    var fl = document.createElement('div');
    fl.className = 'ks-fly-item';
    fl.style.cssText = 'position:fixed;z-index:100000;pointer-events:none;border-radius:12px;overflow:hidden;' +
      'box-shadow:0 8px 30px rgba(44,24,16,0.3);width:' + sz + 'px;height:' + sz + 'px;' +
      'left:' + (ir.left + ir.width/2 - sz/2) + 'px;top:' + (ir.top + ir.height/2 - sz/2) + 'px;' +
      'transition:all 650ms cubic-bezier(0.2,0.8,0.2,1);';
    var im = document.createElement('img');
    im.src = img.src; im.style.cssText = 'width:100%;height:100%;object-fit:cover;';
    fl.appendChild(im); document.body.appendChild(fl);
    requestAnimationFrame(function() { requestAnimationFrame(function() {
      fl.style.left = (cr.left + cr.width/2 - 15) + 'px';
      fl.style.top = (cr.top + cr.height/2 - 15) + 'px';
      fl.style.width = '30px'; fl.style.height = '30px';
      fl.style.opacity = '0.6'; fl.style.borderRadius = '50%';
    }); });
    setTimeout(function() {
      fl.style.opacity = '0'; fl.style.transform = 'scale(0)';
      /* Bounce cart icon */
      if (cart) { cart.classList.remove('ks-cart-bounce'); void cart.offsetWidth; cart.classList.add('ks-cart-bounce'); }
      var badge = document.querySelector('.cart-count');
      if (badge) { badge.classList.remove('ks-count-bump'); void badge.offsetWidth; badge.classList.add('ks-count-bump'); }
      setTimeout(function() { fl.remove(); }, 200);
    }, 650);
  }

  function ksShowMobileConfirm(title) {
    if (window.innerWidth >= 768) return;
    var old = document.querySelector('.ks-confirm-bar'); if (old) old.remove();
    var pi = document.querySelector('.product-gallery img') || document.querySelector('.product-single__media img');
    var src = pi ? pi.src.replace(/(\?.*)?$/, '?width=80') : '';
    var bar = document.createElement('div');
    bar.className = 'ks-confirm-bar'; bar.setAttribute('role', 'status');
    bar.innerHTML = '<div class="ks-confirm-bar__inner">' +
      (src ? '<img class="ks-confirm-bar__img" src="' + src + '" alt="">' : '') +
      '<div class="ks-confirm-bar__text"><svg class="ks-atc-check" viewBox="0 0 24 24" width="18" height="18"><path d="M7 12.5l3 3 7-7" fill="none" stroke="#6FCF97" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<span class="ks-confirm-bar__title">' + title + '</span></div>' +
      '<button class="ks-confirm-bar__btn" type="button">Warenkorb ansehen</button></div>';
    bar.querySelector('.ks-confirm-bar__btn').addEventListener('click', function() {
      bar.classList.remove('ks-confirm-bar--visible');
      setTimeout(function() { bar.remove(); }, 400);
      var ct = document.querySelector('a.cartToggle') || document.querySelector('a[href="/cart"]');
      if (ct) ct.click();
    });
    document.body.appendChild(bar);
    requestAnimationFrame(function() { requestAnimationFrame(function() { bar.classList.add('ks-confirm-bar--visible'); }); });
    setTimeout(function() { bar.classList.remove('ks-confirm-bar--visible'); setTimeout(function() { bar.remove(); }, 400); }, 4000);
  }

  function debounce(fn, delay) {
    var timer;
    return function() {
      var ctx = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function() { fn.apply(ctx, args); }, delay);
    };
  }

  function throttle(fn, limit) {
    var waiting = false;
    return function() {
      if (waiting) return;
      fn.apply(this, arguments);
      waiting = true;
      setTimeout(function() { waiting = false; }, limit);
    };
  }

  /* ── Money Formatting ── */
  KS.formatMoney = function(cents) {
    if (cents == null || isNaN(cents)) return '';
    var format = KS.moneyFormat || '{{amount_with_comma_separator}} €';
    var amount = (cents / 100).toFixed(2);
    var amountComma = amount.replace('.', ',');
    // Handle thousands separator for comma format
    var parts = amountComma.split(',');
    if (parts[0].length > 3) {
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    var amountWithCommaSep = parts.join(',');
    // Handle thousands separator for dot format
    var dotParts = amount.split('.');
    if (dotParts[0].length > 3) {
      dotParts[0] = dotParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    var amountFormatted = dotParts.join('.');

    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithCommaSep)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/g, amountFormatted)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, dotParts[0]);
  };

  /* ── Body scroll lock ── */
  var scrollLockCount = 0;
  var scrollPos = 0;

  function lockScroll() {
    if (scrollLockCount === 0) {
      scrollPos = window.pageYOffset;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = -scrollPos + 'px';
      document.body.style.width = '100%';
    }
    scrollLockCount++;
  }

  function unlockScroll() {
    scrollLockCount--;
    if (scrollLockCount <= 0) {
      scrollLockCount = 0;
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollPos);
    }
  }


  /* ── Focus Trap (BFSG / WCAG 2.1 AA) ── */
  window.KSFocusTrap = function(container) {
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var active = false;
    var triggerEl = null;

    function handleKeydown(e) {
      if (e.key !== 'Tab' || !active) return;
      var focusable = Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE)).filter(function(el) {
        return el.offsetParent !== null;
      });
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    return {
      activate: function() {
        triggerEl = document.activeElement;
        active = true;
        document.addEventListener('keydown', handleKeydown);
        var focusable = container.querySelectorAll(FOCUSABLE);
        if (focusable.length) setTimeout(function() { focusable[0].focus(); }, 50);
      },
      deactivate: function() {
        active = false;
        document.removeEventListener('keydown', handleKeydown);
        if (triggerEl && triggerEl.focus) {
          try { triggerEl.focus(); } catch(e) {}
        }
      }
    };
  };


  /* ═══════════════════════════════════════════
     2. CART API
     ═══════════════════════════════════════════ */

  KS.cart = {
    _data: null,

    get: function() {
      return fetch(KS.routes.cart + '.js', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        KS.cart._data = cart;
        return cart;
      });
    },

    add: function(items) {
      var body = Array.isArray(items) ? { items: items } : { items: [items] };
      return fetch(KS.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(e) { throw e; });
        return r.json();
      })
      .then(function(data) {
        return KS.cart.get().then(function(cart) {
          KS.cart._dispatch(cart);
          return data;
        });
      });
    },

    /* Änderungen laufen nacheinander; neu gezeichnet wird erst nach der letzten.
       Sonst überholen sich schnelle +/−-Klicks (3× + ergab Menge 2 statt 4). */
    change: function(key, qty) {
      KS.cart._pending = (KS.cart._pending || 0) + 1;
      var run = function() {
        /* Shopify vergibt nach einer Änderung neue Zeilen-Keys (z. B. durch Rabatte).
           Darum den aktuellen Key aus dem letzten Warenkorb-Stand holen. */
        var id = key;
        var items = (KS.cart._data && KS.cart._data.items) || [];
        var same = items.filter(function(it) { return it.key === key; })[0];
        if (!same) {
          var vid = String(key).split(':')[0];
          var byVariant = items.filter(function(it) { return String(it.variant_id) === vid; })[0];
          if (byVariant) id = byVariant.key;
        }
        return fetch(KS.routes.cartChange + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: qty })
        }).then(function(r) {
          return r.json().then(function(cart) {
            if (!r.ok) throw cart;
            KS.cart._data = cart;
            return cart;
          });
        });
      };
      KS.cart._queue = (KS.cart._queue || Promise.resolve()).catch(function() {}).then(run);
      return KS.cart._queue.then(function(cart) {
        KS.cart._pending--;
        KS.cart._data = cart;
        if (KS.cart._pending === 0) KS.cart._dispatch(cart);
        return cart;
      }, function(err) {
        KS.cart._pending--;
        throw err;
      });
    },

    update: function(updates) {
      return fetch(KS.routes.cartUpdate + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        KS.cart._data = cart;
        KS.cart._dispatch(cart);
        return cart;
      });
    },

    _dispatch: function(cart) {
      document.dispatchEvent(new CustomEvent('ks:cart:updated', {
        detail: { cart: cart }
      }));
      KS.cart._updateBadges(cart);
    },

    _updateBadges: function(cart) {
      var badges = document.querySelectorAll('[data-cart-count]');
      badges.forEach(function(badge) {
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
      });
    }
  };


  /* ═══════════════════════════════════════════
     3. CART DRAWER
     ═══════════════════════════════════════════ */

  var CartDrawer = (function() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-overlay]');
    var focusTrap = null;

    if (!drawer || !overlay) {
      /* Drawer not in DOM — still intercept cart icon clicks to prevent /cart navigation */
      document.addEventListener('click', function(e) {
        var icon = e.target.closest('[data-cart-icon]');
        if (icon) {
          /* Try to find drawer again (might have loaded late) */
          var d = document.querySelector('[data-cart-drawer]');
          var o = document.querySelector('[data-cart-overlay]');
          if (d && o) {
            e.preventDefault();
            d.classList.add('is-open');
            o.classList.add('is-open');
            d.setAttribute('aria-hidden', 'false');
            lockScroll();
          }
        }
      });
      return { open: function(){}, close: function(){}, refresh: function(){} };
    }

    if (window.KSFocusTrap) {
      focusTrap = window.KSFocusTrap(drawer);
    }

    function open() {
      /* Don't open if upsell overlay is active */
      if (KS._upsellActive) return;
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      lockScroll();
      if (focusTrap) focusTrap.activate();
    }

    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      unlockScroll();
      if (focusTrap) focusTrap.deactivate();
    }

    function refresh() {
      return fetch('/?section_id=ks-cart-drawer')
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var newContent = tmp.querySelector('[data-cart-drawer]');
          if (newContent) {
            drawer.innerHTML = newContent.innerHTML;
          }
        });
    }

    /* Open trigger — cart icon clicks */
    document.addEventListener('click', function(e) {
      var cartIcon = e.target.closest('[data-cart-icon]');
      if (cartIcon) {
        e.preventDefault();
        open();
      }
    });

    /* Close triggers */
    overlay.addEventListener('click', close);

    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-cart-drawer-close]')) {
        close();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        close();
      }
    });

    /* Quantity and remove buttons via delegation */
    drawer.addEventListener('click', function(e) {
      var minus = e.target.closest('[data-cart-qty-minus]');
      var plus = e.target.closest('[data-cart-qty-plus]');
      var remove = e.target.closest('[data-cart-remove]');

      if (minus || plus) {
        var btn = minus || plus;
        var key = btn.getAttribute('data-line-key');
        var qty = Math.max(0, parseInt(btn.getAttribute('data-qty'), 10));
        /* Sofort weiterzählen, damit schnelle Klicks nicht auf alten data-qty-Werten landen */
        var box = btn.parentElement;
        var m = box.querySelector('[data-cart-qty-minus]');
        var p = box.querySelector('[data-cart-qty-plus]');
        var d = box.querySelector('[data-cart-qty-display]');
        if (m) m.setAttribute('data-qty', Math.max(0, qty - 1));
        if (p) p.setAttribute('data-qty', qty + 1);
        if (d) d.textContent = qty;
        KS.cart.change(key, qty);
      }

      if (remove) {
        var key = remove.getAttribute('data-line-key');
        KS.cart.change(key, 0);
      }
    });

    /* Listen for cart updates to refresh drawer */
    document.addEventListener('ks:cart:updated', function(e) {
      refresh().then(function() {
        updateShippingBar(e.detail.cart);
      });
    });

    function updateShippingBar(cart) {
      var threshold = parseInt(KS.freeShippingThreshold, 10) || 10000;
      var total = cart.total_price;
      var remaining = threshold - total;
      var progress = Math.min(100, (total / threshold) * 100);

      var shippingEl = drawer.querySelector('[data-cart-shipping]');
      if (!shippingEl) return;

      var fill = shippingEl.querySelector('[data-cart-shipping-fill]');
      if (fill) fill.style.width = progress + '%';

      var textEl = shippingEl.querySelector('.cart-drawer__shipping-text');
      if (!textEl) return;

      if (remaining <= 0) {
        textEl.className = 'cart-drawer__shipping-text cart-drawer__shipping-reached';
        textEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:16px;height:16px;flex-shrink:0"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
          (KS.strings.freeShippingReached || 'Du hast kostenlosen Versand!');
      } else {
        textEl.className = 'cart-drawer__shipping-text';
        var msg = (KS.strings.freeShippingRemaining || 'Noch {amount} bis kostenloser Versand')
          .replace('{amount}', KS.formatMoney(remaining));
        textEl.textContent = msg;
      }
    }

    /* Update drawer title with count */
    document.addEventListener('ks:cart:updated', function(e) {
      var titleEl = drawer.querySelector('[data-cart-drawer-title]');
      if (titleEl) {
        titleEl.textContent = 'Warenkorb (' + e.detail.cart.item_count + ')';
      }
    });

    return {
      open: open,
      close: close,
      refresh: refresh
    };
  })();

  KS.cartDrawer = CartDrawer;


  /* ═══════════════════════════════════════════
     4. PRODUCT FORM — AJAX ADD TO CART
     ═══════════════════════════════════════════ */

  document.addEventListener('submit', function(e) {
    var form = e.target.closest('[data-pdp-form], form[action*="/cart/add"]');
    if (!form) return;

    /* Only intercept if cart type is drawer or if form has data-pdp-form */
    if (KS.cartType !== 'drawer' && !form.hasAttribute('data-pdp-form')) return;

    e.preventDefault();

    var atcBtn = form.querySelector('[data-pdp-atc], [type="submit"]');
    var atcText = form.querySelector('[data-pdp-atc-text], .btn__label');

    /* Loading state */
    if (atcBtn) {
      atcBtn.classList.add('is-loading');
      atcBtn.disabled = true;
    }

    var formData = new FormData(form);
    var items = [{
      id: parseInt(formData.get('id'), 10),
      quantity: parseInt(formData.get('quantity'), 10) || 1
    }];

    /* Handle properties if present */
    var properties = {};
    formData.forEach(function(value, key) {
      if (key.indexOf('properties[') === 0) {
        var propName = key.replace('properties[', '').replace(']', '');
        properties[propName] = value;
      }
    });
    if (Object.keys(properties).length > 0) {
      items[0].properties = properties;
    }

    KS.cart.add(items)
      .then(function() {
        /* Success feedback — premium ATC experience */
        if (atcBtn) {
          atcBtn.classList.remove('is-loading');
          atcBtn.disabled = false;

          /* 1. Pulse animation */
          atcBtn.classList.add('ks-atc--pulse');
          setTimeout(function() { atcBtn.classList.remove('ks-atc--pulse'); }, 250);

          /* 2. Green success state with animated checkmark */
          setTimeout(function() {
            atcBtn.classList.add('is-success', 'ks-atc--success');
            if (atcText) {
              var origText = atcText.textContent;
              atcText.innerHTML = '<svg class="ks-atc-check" viewBox="0 0 24 24" width="20" height="20"><path d="M7 12.5l3 3 7-7" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="ks-atc-check__path"/></svg> ' +
                (KS.strings.added || 'Hinzugefügt!');

              setTimeout(function() {
                atcBtn.classList.remove('is-success', 'ks-atc--success');
                if (atcText) atcText.textContent = origText;
              }, 2200);
            }
          }, 200);

          /* 3. Sound + Haptic */
          setTimeout(function() {
            ksPlayDing();
            if (navigator.vibrate) navigator.vibrate([12, 25, 12]);
          }, 250);
        }

        /* 4. Fly-to-Cart animation */
        setTimeout(ksFlyToCart, 150);

        /* 5. Mobile confirm bar */
        var pTitle = form.getAttribute('data-product-title') ||
          (document.querySelector('.product__title h1, .product__title, h1') || {}).textContent || 'Produkt';
        setTimeout(function() {
          if (window.innerWidth < 768) ksShowMobileConfirm(pTitle.trim());
        }, 900);

        /* Upsell overlay instead of cart drawer */
        var productId = form.getAttribute('data-product-id');
        var productTitle = form.getAttribute('data-product-title');
        if (KS.upsellOverlay && productId) {
          /* Suppress cart drawer while upsell is active */
          KS._upsellActive = true;
          setTimeout(function() {
            /* Force-close drawer if it opened */
            if (KS.cartDrawer && KS.cartDrawer.close) KS.cartDrawer.close();
            KS.upsellOverlay.open(productId, productTitle);
          }, 100);
        } else if (KS.cartType === 'drawer') {
          setTimeout(function() {
            CartDrawer.open();
          }, 300);
        }
      })
      .catch(function(err) {
        if (atcBtn) {
          atcBtn.classList.remove('is-loading');
          atcBtn.disabled = false;
        }
        console.error('Add to cart error:', err);
        /* Show error if available */
        if (err && err.description) {
          alert(err.description);
        }
      });
  });


  /* ═══════════════════════════════════════════
     5. HEADER — Sticky + Hide/Show on Scroll
     ═══════════════════════════════════════════ */

  (function() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var isTransparent = header.getAttribute('data-header-transparent') === 'true';
    var lastScrollY = 0;
    var ticking = false;
    var scrollThreshold = 50;
    var hideThreshold = 200;

    function onScroll() {
      if (ticking) return;

      requestAnimationFrame(function() {
        var scrollY = window.pageYOffset;

        /* is-scrolled class */
        if (scrollY > scrollThreshold) {
          header.classList.add('is-scrolled');
          if (isTransparent) {
            header.style.position = 'fixed';
          }
        } else {
          header.classList.remove('is-scrolled');
          if (isTransparent) {
            header.style.position = 'absolute';
          }
        }

        /* Hide on scroll down, show on scroll up (after hideThreshold) */
        if (scrollY > hideThreshold) {
          if (scrollY > lastScrollY + 5) {
            /* Scrolling down */
            header.style.transform = 'translateY(-100%)';
          } else if (scrollY < lastScrollY - 5) {
            /* Scrolling up */
            header.style.transform = 'translateY(0)';
          }
        } else {
          header.style.transform = 'translateY(0)';
        }

        lastScrollY = scrollY;
        ticking = false;
      });

      ticking = true;
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    /* Add transition for transform after initial load to avoid flash */
    setTimeout(function() {
      header.style.transition = 'transform 0.3s var(--ease, ease), background 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease';
    }, 100);
  })();


  /* ═══════════════════════════════════════════
     6. MOBILE MENU
     ═══════════════════════════════════════════ */

  (function() {
    var menu = document.getElementById('mobile-menu');
    if (!menu) return;

    /* Skip if inline section script already bound everything */
    if (window.KS && window.KS.mobileMenu) return;

    var focusTrap = window.KSFocusTrap ? window.KSFocusTrap(menu) : null;

    function openMenu() {
      menu.classList.add('is-open');
      lockScroll();
      if (focusTrap) focusTrap.activate();
      var hamburger = document.querySelector('[data-mobile-menu-open]');
      if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      unlockScroll();
      if (focusTrap) focusTrap.deactivate();
      var hamburger = document.querySelector('[data-mobile-menu-open]');
      if (hamburger) {
        hamburger.setAttribute('aria-expanded', 'false');
      }
    }

    /* Open trigger */
    var hamburger = document.querySelector('[data-mobile-menu-open]');
    if (hamburger) {
      hamburger.addEventListener('click', openMenu);
    }

    /* Close triggers */
    menu.querySelectorAll('[data-mobile-menu-close]').forEach(function(btn) {
      btn.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) {
        closeMenu();
      }
    });

    /* Accordion toggles */
    menu.querySelectorAll('[data-menu-toggle]').forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var children = toggle.closest('.mobile-menu__item').querySelector('[data-menu-children]');
        if (!children) return;
        var isOpen = children.classList.contains('is-open');
        children.classList.toggle('is-open');
        toggle.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });

    window.KS = window.KS || {};
    window.KS.mobileMenu = { open: openMenu, close: closeMenu };
  })();


  /* ═══════════════════════════════════════════
     7. SEARCH OVERLAY
     ═══════════════════════════════════════════ */

  (function() {
    var overlay = document.querySelector('[data-search-overlay]');
    var input = document.querySelector('[data-search-input]');
    var results = document.querySelector('[data-search-results]');
    var clearBtn = document.querySelector('[data-search-clear]');
    if (!overlay || !input) return;

    var focusTrap = window.KSFocusTrap ? window.KSFocusTrap(overlay) : null;

    function open() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      lockScroll();
      setTimeout(function() { input.focus(); }, 100);
      if (focusTrap) focusTrap.activate();
    }

    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      unlockScroll();
      input.value = '';
      if (results) results.innerHTML = '';
      if (clearBtn) clearBtn.classList.remove('is-visible');
      if (focusTrap) focusTrap.deactivate();
    }

    window.KS = window.KS || {};
    window.KS.searchOverlay = { open: open, close: close };

    /* Open triggers */
    document.querySelectorAll('.site-header__icon--search, [data-search-open]').forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        open();
      });
    });

    /* Close */
    overlay.querySelectorAll('[data-search-close]').forEach(function(btn) {
      btn.addEventListener('click', close);
    });

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        close();
      }
    });

    /* Clear */
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        input.value = '';
        input.focus();
        clearBtn.classList.remove('is-visible');
        if (results) results.innerHTML = '';
      });
    }

    /* Predictive search with debounce */
    var fetchResults = debounce(function(query) {
      if (!results) return;

      results.innerHTML = '<p class="search-overlay__loading">Suche...</p>';

      var url = KS.routes.predictiveSearch + '.json'
        + '?q=' + encodeURIComponent(query)
        + '&resources[type]=product&resources[limit]=6';

      fetch(url)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = (data.resources && data.resources.results && data.resources.results.products)
            ? data.resources.results.products : [];

          if (products.length === 0) {
            results.innerHTML = '<p class="search-overlay__no-results">Keine Ergebnisse für „' + escapeHtml(query) + '“</p>';
            return;
          }

          var html = '<p class="search-overlay__results-heading">Produkte</p>';
          products.forEach(function(p) {
            html += '<a href="' + p.url + '" class="search-overlay__result-item">';
            if (p.image) {
              html += '<img class="search-overlay__result-img" src="' + p.image + '" alt="" width="56" height="56" loading="lazy">';
            }
            html += '<div class="search-overlay__result-info">';
            html += '<p class="search-overlay__result-title">' + escapeHtml(p.title) + '</p>';
            html += '<p class="search-overlay__result-price">' + (isNaN(parseFloat(p.price)) ? p.price : (p.price_max && p.price_max !== p.price ? 'ab ' : '') + KS.formatMoney(Math.round(parseFloat(p.price) * 100))) + '</p>';
            html += '</div></a>';
          });

          html += '<a href="' + KS.routes.search + '?q=' + encodeURIComponent(query) + '&type=product" class="search-overlay__view-all">Alle Ergebnisse anzeigen</a>';
          results.innerHTML = html;
        })
        .catch(function() {
          results.innerHTML = '<p class="search-overlay__no-results">Suche fehlgeschlagen. Bitte erneut versuchen.</p>';
        });
    }, 300);

    input.addEventListener('input', function() {
      var query = this.value.trim();
      if (clearBtn) {
        clearBtn.classList.toggle('is-visible', query.length > 0);
      }
      if (query.length < 2) {
        if (results) results.innerHTML = '';
        return;
      }
      fetchResults(query);
    });
  })();

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }


  /* ═══════════════════════════════════════════
     8. ANNOUNCEMENT BAR — Auto-Rotate
     ═══════════════════════════════════════════ */

  (function() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;

    var messages = bar.querySelectorAll('[data-announcement-msg]');
    if (messages.length <= 1) return;

    var current = 0;
    var interval = 4000;

    function rotate() {
      messages[current].classList.remove('is-active');
      current = (current + 1) % messages.length;
      messages[current].classList.add('is-active');
    }

    /* Only auto-rotate on mobile */
    var mql = window.matchMedia('(max-width: 749px)');
    var timer = null;

    function startRotation() {
      if (timer) return;
      timer = setInterval(rotate, interval);
    }

    function stopRotation() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function handleMediaChange(e) {
      if (e.matches) {
        startRotation();
      } else {
        stopRotation();
      }
    }

    if (mql.addEventListener) {
      mql.addEventListener('change', handleMediaChange);
    } else if (mql.addListener) {
      mql.addListener(handleMediaChange);
    }

    if (mql.matches) startRotation();
  })();


  /* ═══════════════════════════════════════════
     9. SCROLL ANIMATIONS
     ═══════════════════════════════════════════ */

  (function() {
    if (!KS.enableAnimations) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var reveals = document.querySelectorAll('.reveal');
    if (reveals.length === 0) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    });

    reveals.forEach(function(el) {
      observer.observe(el);
    });

    /* Observe dynamically added .reveal elements via MutationObserver */
    var bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('reveal')) {
            observer.observe(node);
          }
          var nested = node.querySelectorAll ? node.querySelectorAll('.reveal') : [];
          nested.forEach(function(el) { observer.observe(el); });
        });
      });
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  })();


  /* ═══════════════════════════════════════════
     10. QUANTITY SELECTORS (global)
     ═══════════════════════════════════════════ */

  document.addEventListener('click', function(e) {
    var minus = e.target.closest('[data-qty-minus], [data-pdp-qty-minus]');
    var plus = e.target.closest('[data-qty-plus], [data-pdp-qty-plus]');

    if (!minus && !plus) return;

    var wrap = (minus || plus).closest('.ks-pdp__qty-wrap, .qty-selector, [data-qty-wrap]');
    if (!wrap) return;

    var input = wrap.querySelector('input[type="number"], [data-qty-input], [data-pdp-qty-input]');
    if (!input) return;

    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 9999;

    if (minus && val > min) {
      input.value = val - 1;
    } else if (plus && val < max) {
      input.value = val + 1;
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });


  /* ═══════════════════════════════════════════
     11. IMAGE GALLERY (Product Page)
     ═══════════════════════════════════════════ */

  (function() {
    var section = document.querySelector('[data-ks-pdp], [data-section-type="product"]');
    if (!section) return;

    var mainImg = section.querySelector('[data-pdp-main-img]');
    var thumbs = section.querySelectorAll('[data-pdp-thumb]');
    var mobileScroll = section.querySelector('[data-pdp-mobile-scroll]');
    var dots = section.querySelectorAll('[data-pdp-dot]');

    /* Desktop: thumbnail click swaps main image */
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) {
          mainImg.style.opacity = '0';
          setTimeout(function() {
            mainImg.src = thumb.getAttribute('data-img-src');
            mainImg.srcset = thumb.getAttribute('data-img-srcset') || '';
            mainImg.onload = function() {
              mainImg.style.opacity = '1';
            };
          }, 150);
        }
      });
    });

    /* Mobile: dot indicators via IntersectionObserver */
    if (mobileScroll && dots.length > 0) {
      var slides = Array.from(mobileScroll.children);

      var dotObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var idx = slides.indexOf(entry.target);
            dots.forEach(function(d, di) {
              d.classList.toggle('is-active', di === idx);
            });
          }
        });
      }, { root: mobileScroll, threshold: 0.6 });

      slides.forEach(function(slide) { dotObserver.observe(slide); });

      /* Dot click scrolls to slide */
      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var idx = parseInt(dot.getAttribute('data-pdp-dot'), 10);
          if (slides[idx]) {
            slides[idx].scrollIntoView({
              behavior: 'smooth',
              inline: 'center',
              block: 'nearest'
            });
          }
        });
      });
    }
  })();


  /* ═══════════════════════════════════════════
     12. INITIALIZE CAROUSELS
     ═══════════════════════════════════════════ */

  (function() {
    if (!window.KSCarousel) return;

    /* Featured collection carousels */
    document.querySelectorAll('.fc__grid--carousel').forEach(function(grid) {
      var section = grid.closest('.section, [data-section-id]');
      if (!section) return;

      KSCarousel(grid, {
        prevBtn: section.querySelector('[data-carousel-prev]'),
        nextBtn: section.querySelector('[data-carousel-next]')
      });
    });

    /* Testimonials carousels */
    document.querySelectorAll('[data-testimonials-track]').forEach(function(track) {
      var section = track.closest('.section, [data-section-id]');
      if (!section) return;

      KSCarousel(track, {
        prevBtn: section.querySelector('[data-carousel-prev]'),
        nextBtn: section.querySelector('[data-carousel-next]'),
        dots: section.querySelector('[data-carousel-dots]')
      });
    });

    /* Standorte carousel */
    document.querySelectorAll('[data-standorte-track]').forEach(function(track) {
      var section = track.closest('.section, [data-section-id]');
      if (!section) return;

      KSCarousel(track, {
        prevBtn: section.querySelector('[data-carousel-prev]'),
        nextBtn: section.querySelector('[data-carousel-next]')
      });
    });
  })();


  /* ═══════════════════════════════════════════
     13. QUICK-ADD TO CART (Product Cards)
     ═══════════════════════════════════════════ */
  (function() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.getAttribute('data-quick-add');
      if (!variantId || btn.classList.contains('is-loading') || btn.hasAttribute('data-cooldown')) return;
      btn.setAttribute('data-cooldown', '1');

      /* Get product info for upsell */
      var card = btn.closest('[data-product-card]');
      var productId = btn.getAttribute('data-product-id') || '';
      var productTitle = '';
      if (card) {
        var titleEl = card.querySelector('.pc__title');
        if (titleEl) productTitle = titleEl.textContent.trim();
      }

      /* Loading state */
      btn.classList.add('is-loading');
      var origHTML = btn.innerHTML;
      btn.innerHTML = '<svg class="spin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>';

      KS.cart.add([{ id: parseInt(variantId, 10), quantity: 1 }])
      .then(function() {
        /* Success state */
        btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

        /* Sound + Haptic */
        ksPlayDing();
        if (navigator.vibrate) navigator.vibrate([12, 25, 12]);

        /* Refresh cart drawer */
        if (KS.cartDrawer && KS.cartDrawer.refresh) {
          KS.cartDrawer.refresh();
        }

        /* Show upsell overlay if available, otherwise open cart drawer */
        if (KS.upsellOverlay && productId) {
          KS._upsellActive = true;
          KS.upsellOverlay.open(productId, productTitle);
        } else if (KS.cartDrawer && KS.cartDrawer.open) {
          KS.cartDrawer.open();
        }

        /* Toast */
        if (KS.toast) KS.toast(KS.strings.added || 'Hinzugefügt!', 'success');

        setTimeout(function() { btn.innerHTML = origHTML; btn.classList.remove('is-loading'); btn.removeAttribute('data-cooldown'); }, 1500);
      })
      .catch(function() {
        btn.innerHTML = origHTML;
        btn.classList.remove('is-loading');
        btn.removeAttribute('data-cooldown');
        if (KS.toast) KS.toast('Fehler beim Hinzufügen', '');
      });
    });
  })();


  /* ═══════════════════════════════════════════
     14. ATC UPSELL OVERLAY
     ═══════════════════════════════════════════ */
  var UpsellOverlay = (function() {
    var overlay = document.getElementById('ks-upsell-overlay');
    var productContainer = document.getElementById('ks-upsell-product');
    var addBtn = document.getElementById('ks-upsell-add-btn');
    var addedText = document.getElementById('ks-upsell-added-text');
    if (!overlay || !productContainer || !addBtn) return null;

    var currentVariantId = null;
    var isOpen = false;
    var focusTrap = window.KSFocusTrap ? window.KSFocusTrap(overlay) : null;

    /* Close handlers */
    overlay.querySelectorAll('[data-upsell-close]').forEach(function(el) {
      el.addEventListener('click', function() {
        close();
        /* Open cart drawer after closing */
        if (KS.cartDrawer && KS.cartDrawer.open) {
          setTimeout(function() { KS.cartDrawer.open(); }, 150);
        }
      });
    });

    /* ESC key */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) {
        close();
        if (KS.cartDrawer && KS.cartDrawer.open) {
          setTimeout(function() { KS.cartDrawer.open(); }, 150);
        }
      }
    });

    /* Add upsell product to cart */
    addBtn.addEventListener('click', function() {
      if (!currentVariantId || addBtn.classList.contains('is-loading')) return;

      addBtn.classList.add('is-loading');
      var origHTML = addBtn.innerHTML;
      addBtn.innerHTML = '<svg class="spin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg> Wird hinzugefügt…';

      KS.cart.add([{ id: parseInt(currentVariantId, 10), quantity: 1 }])
        .then(function() {
          addBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Hinzugefügt!';
          addBtn.style.background = 'var(--c-success)';
          if (KS.toast) KS.toast('Hinzugefügt!', 'success');

          setTimeout(function() {
            close();
            addBtn.innerHTML = origHTML;
            addBtn.style.background = '';
            addBtn.classList.remove('is-loading');
            if (KS.cartDrawer && KS.cartDrawer.open) {
              setTimeout(function() { KS.cartDrawer.open(); }, 150);
            }
          }, 800);
        })
        .catch(function() {
          addBtn.innerHTML = origHTML;
          addBtn.classList.remove('is-loading');
          if (KS.toast) KS.toast('Fehler beim Hinzufügen', '');
        });
    });

    /* ── Smart recommendation reason based on product data ── */
    function getRecoReason(reco, addedTitle, wasComplementary) {
      var tags = (reco.tags || []).map(function(t) { return t.toLowerCase(); });
      var type = (reco.product_type || '').toLowerCase();

      /* Check if recommendation is same category as added product */
      var isEspresso = tags.indexOf('espresso') !== -1 || type.indexOf('espresso') !== -1;
      var isFilter = tags.indexOf('filter') !== -1 || tags.indexOf('filterkaffee') !== -1 || type.indexOf('filter') !== -1;
      var isOmni = tags.indexOf('omniroast') !== -1 || type.indexOf('omni') !== -1;
      var isLimited = tags.indexOf('limited') !== -1 || tags.indexOf('sack limited') !== -1;
      var isFeinkost = type.indexOf('feinkost') !== -1 || type.indexOf('likör') !== -1 || type.indexOf('schokolade') !== -1 || tags.indexOf('feinkost') !== -1;
      var isProbierbox = tags.indexOf('probierbox') !== -1 || tags.indexOf('set') !== -1 || reco.title.toLowerCase().indexOf('paket') !== -1;

      if (isProbierbox) return 'Perfekt zum Probieren:';
      if (isLimited) return 'Limitiert — nur solange der Vorrat reicht:';
      if (isFeinkost) return 'Dazu passt aus unserer Feinkost:';
      if (wasComplementary) {
        if (isEspresso) return 'Kunden mit diesem Kaffee lieben auch diesen Espresso:';
        if (isFilter) return 'Passt dazu — ein fruchtiger Filterkaffee:';
        return 'Unsere Kunden kombinieren gerne:';
      }
      if (isEspresso) return 'Noch ein Espresso-Favorit:';
      if (isFilter) return 'Noch ein Filterkaffee-Tipp:';
      if (isOmni) return 'Vielseitig als Espresso & Filter:';
      return 'Könnte dir auch schmecken:';
    }

    /* ── Pick best variant (prefer 1kg) ── */
    function pickBestVariant(reco) {
      var variants = reco.variants || [];
      if (variants.length <= 1) return variants[0] || null;
      /* Try to find 1kg variant */
      for (var vi = 0; vi < variants.length; vi++) {
        var vTitle = (variants[vi].title || '').toLowerCase();
        if (variants[vi].available && (vTitle.indexOf('1 kg') !== -1 || vTitle.indexOf('1kg') !== -1 || vTitle.indexOf('1000') !== -1)) {
          return variants[vi];
        }
      }
      /* Fallback: largest available variant */
      for (var vi2 = variants.length - 1; vi2 >= 0; vi2--) {
        if (variants[vi2].available) return variants[vi2];
      }
      return variants[0];
    }

    function open(productId, addedProductTitle) {
      if (!productId) return;

      /* Update added text */
      if (addedText && addedProductTitle) {
        addedText.textContent = addedProductTitle + ' im Warenkorb!';
      } else if (addedText) {
        addedText.textContent = 'Im Warenkorb!';
      }

      /* Show loading state */
      productContainer.innerHTML = '<p style="color:var(--c-text-muted);font-size:0.8125rem;padding:var(--sp-sm);text-align:center;">Empfehlung wird geladen…</p>';
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
      isOpen = true;
      if (focusTrap) focusTrap.activate();

      var wasComplementary = false;

      /* Fetch recommendations from Shopify API */
      fetch(KS.routes.root + 'recommendations/products.json?product_id=' + productId + '&limit=6&intent=complementary')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = (data.products || []).filter(function(p) { return p.available && p.id.toString() !== productId.toString(); });

          /* Fallback to related if no complementary */
          if (products.length === 0) {
            wasComplementary = false;
            return fetch(KS.routes.root + 'recommendations/products.json?product_id=' + productId + '&limit=6&intent=related')
              .then(function(r) { return r.json(); })
              .then(function(d) { return (d.products || []).filter(function(p) { return p.available && p.id.toString() !== productId.toString(); }); });
          }
          wasComplementary = true;
          return products;
        })
        .then(function(products) {
          if (!products || products.length === 0) {
            /* No recommendations — just close and open cart */
            close();
            if (KS.cartDrawer && KS.cartDrawer.open) {
              setTimeout(function() { KS.cartDrawer.open(); }, 150);
            }
            return;
          }

          /* Pick a random product from top results for variety */
          var reco = products[Math.floor(Math.random() * Math.min(products.length, 3))];
          var variant = pickBestVariant(reco);
          if (!variant) { close(); return; }
          currentVariantId = variant.id;

          /* Smart recommendation label */
          var recoLabel = document.querySelector('.ks-upsell-overlay__reco-label');
          if (recoLabel) {
            recoLabel.textContent = getRecoReason(reco, addedProductTitle, wasComplementary);
          }

          /* Format price using KS helper (cents) */
          var priceCents = parseInt(variant.price, 10);
          var price = KS.formatMoney ? KS.formatMoney(priceCents) : ((priceCents / 100).toFixed(2).replace('.', ',') + ' €');

          /* Variant size label */
          var sizeLabel = '';
          if (variant.title && variant.title !== 'Default Title') {
            sizeLabel = '<span style="font-size:0.75rem;color:var(--c-text-muted);font-weight:400;"> · ' + variant.title + '</span>';
          }

          /* Build product card — Shopify API returns full image URLs */
          var imgSrc = reco.featured_image || (reco.images && reco.images[0]) || '';
          if (imgSrc && imgSrc.indexOf('?') === -1) {
            imgSrc += '?width=180&height=180&crop=center';
          } else if (imgSrc) {
            imgSrc += '&width=180&height=180&crop=center';
          }
          var imgTag = imgSrc ? '<img class="ks-upsell-overlay__product-img" src="' + imgSrc + '" alt="' + reco.title.replace(/"/g, '&quot;') + '" width="72" height="72" loading="eager">' : '';

          productContainer.innerHTML =
            '<a href="' + reco.url + '" style="flex-shrink:0">' + imgTag + '</a>' +
            '<div class="ks-upsell-overlay__product-info">' +
              '<p class="ks-upsell-overlay__product-title">' + reco.title + sizeLabel + '</p>' +
              '<p class="ks-upsell-overlay__product-price">' + price + '</p>' +
            '</div>';
        })
        .catch(function(err) {
          console.error('Upsell fetch error:', err);
          close();
          if (KS.cartDrawer && KS.cartDrawer.open) {
            setTimeout(function() { KS.cartDrawer.open(); }, 150);
          }
        });
    }

    function close() {
      if (focusTrap) focusTrap.deactivate();
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
      isOpen = false;
      currentVariantId = null;
      /* Re-enable cart drawer */
      KS._upsellActive = false;
    }

    return { open: open, close: close };
  })();

  KS.upsellOverlay = UpsellOverlay;


  /* ═══════════════════════════════════════════
     EXPOSE
     ═══════════════════════════════════════════ */

  window.KS = KS;

})();
